import { useContext } from 'react';
import { HeaderFiltersContext } from './types';

export const useHeaderFilters = () => {
  const context = useContext(HeaderFiltersContext);
  if (!context) {
    throw new Error('useHeaderFilters must be used within HeaderFiltersProvider');
  }
  return context;
};
